module.exports = __webpack_public_path__ + "img/asaas.d1f16419.svg";